<template>
  <p :style="customStyle" class="generic-text">
    {{ text }}
  </p>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
  },
  computed: {
    text() {
      return _.get(this.component, 'value', '')
    },
    customStyle() {
      return _.get(this.component, 'props.style', {})
    }
  },
}
</script>

<style lang="scss" scoped>
.generic-text {
  color: var(--text);
  margin-bottom: 0;
}
</style>
